var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccelerator = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E869E",
    d: "M2.748 13.795c-1.188-8.36 9.167-11.543 12.065-4.37L17.9 8C11.298-1.928-.435 6.29 2.748 13.795M17.9 8.95l-8.36 6.508c-1.425.57-2.422-1.473-1.235-2.138z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeWidth: 0.095,
    d: "M2.748 13.795c-1.188-8.36 9.167-11.543 12.065-4.37L17.9 8C11.298-1.928-.435 6.29 2.748 13.795ZM17.9 8.95l-8.36 6.508c-1.425.57-2.422-1.473-1.235-2.138z"
  })));
};
export default SvgAccelerator;